import React, { useEffect, useState } from "react";
import AdminAccess from "../dataAccess/AdminAccess";
import Error from "../components/Error";

export default function RequireAdmin({ children }) {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    AdminAccess.getCurrentUserRole()
      .then((res) => setIsAdmin(Number(res.data?.[0]?.IsAdmin) === 1))
      .catch(() => setIsAdmin(false));
  }, []);

  if (isAdmin === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100vw' }}>
        <img className="logo-loader logo-loader--pulse" src="/logo2.svg" alt="Loading" />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <Error
        kind="empty"
        line1="Access Restricted"
        line2="Your account does not have admin access."
        line3="Contact your administrator if you believe this is a mistake."
      />
    );
  }

  return <>{children}</>;
}
